module.exports = __webpack_public_path__ + "assets/8b372f3ee373340d864b605ee4ab3e6e.png";